import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CommonModal } from 'wsm-common-modal';
import {
	getIncentivePrefix,
	getPaymentLabel,
	getPaymentPrefix
} from '../helpers';
import useTrackEvent from '../hooks/useTrackEvent';

const SpecialItems = ({ incentives, payment }) => {
	const [isOpenModal, setOpenModal] = useState(false);
	const [clickIncentive, setClickIncentive] = useState({});
	const sendTrackEvent = useTrackEvent();

	if (!payment) {
		return null;
	}
	const isCashTabWithNoIncentives =
		payment?.paymentLabel?.toLowerCase() === 'cash' && !incentives?.length;

	const toggleOpenModal = () => {
		setOpenModal((previous) => !previous);
	};

	const openIncentiveDetailModal = (incentive) => {
		const startDate = new Date(
			incentive.startDate?.includes('T')
				? incentive.startDate
				: `${incentive.startDate}T00:00:00`
		);
		const endDate = new Date(
			incentive.endDate?.includes('T')
				? incentive.endDate
				: `${incentive.endDate}T00:00:00`
		);
		return (
			<>
				<div className="mb-3">
					<b> Program Name: </b> {incentive.programName}
				</div>
				{incentive.description !== '' && (
					<div className="mb-3">
						<b>Description: </b>
						{incentive.description}
					</div>
				)}
				{incentive.cash !== 0 && (
					<div className="mb-3">
						<b>Cash Back:</b> ${incentive.cash}
					</div>
				)}
				<div className="mb-3">
					<b>Effective </b>
					{startDate.toDateString()} through {endDate.toDateString()}
				</div>
				<div className="mb-3">
					<b>Incentive Type: </b> {incentive.incentiveType}
				</div>
				<div className="mb-3">
					<b>Funding Source: </b> {incentive.fundingSource}
				</div>
			</>
		);
	};

	const openClickIncentive = (incentive) => {
		toggleOpenModal();
		setClickIncentive(incentive);
		sendTrackEvent({
			element: 'Specials Link',
			elementCTA: incentive.prefix,
			result: 'Open special in modal'
		});
	};

	// display incentives
	if (incentives.length) {
		const sortedIncentives = incentives
			.map((incentive) => {
				return {
					...incentive,
					prefix: getIncentivePrefix(incentive, payment),
					label: getPaymentLabel(incentive, payment)
				};
			})
			// sort these incentives by their prefix descending
			.sort((a, b) => b.prefix.localeCompare(a.prefix));

		return (
			<>
				{sortedIncentives.map((incentive, index) => {
					return (
						<div
							className="d-flex flex-row my-2"
							key={`incentive-${
								incentive.incentiveId || incentive.id || index
							}`}
						>
							<button
								className="incentive-link text-left text-link text-link-muted mr-3 ddc-font-size-xsmall"
								onClick={() => openClickIncentive(incentive)}
								type="button"
							>
								<span className="mr-2 text-decoration-underline">
									{incentive.prefix}
								</span>
								<span className="text-discount">
									{incentive.label}
								</span>
							</button>
						</div>
					);
				})}
				<CommonModal
					title={`${clickIncentive.programType}  special`}
					isOpen={isOpenModal}
					onClose={toggleOpenModal}
					key="common-modal"
				>
					{openIncentiveDetailModal(clickIncentive)}
				</CommonModal>
			</>
		);
	}
	// default display
	return (
		!isCashTabWithNoIncentives && (
			<div
				className="d-flex flex-row my-2 text-left ddc-font-size-xsmall"
				key={`payment-${payment?.key}`}
			>
				<span className="mr-2">{getPaymentPrefix(payment)}</span>
				<span>{getPaymentLabel({}, payment)}</span>
			</div>
		)
	);
};

SpecialItems.propTypes = {
	incentives: PropTypes.arrayOf(PropTypes.shape({})),
	payment: PropTypes.shape({
		paymentLabel: PropTypes.string,
		paymentTerm: PropTypes.string,
		apr: PropTypes.number,
		downPayment: PropTypes.number,
		annualMiles: PropTypes.number,
		key: PropTypes.string
	}).isRequired
};

export default SpecialItems;
